import {
  AreaInfo,
  GoodsListItem,
  GoodsDetails,
  LoginedInfo,
  LoginedWxInfo,
  OrderListItem,
  ErrorInfo,
  PostOrderResult,
} from "@/types/index";

import {
  getArea,
  getAreaV3,
  getCache,
  getWxConfig as getWxConfigV2,
  getWxConfigV3,
  getGoodsList as getGoodListV2,
  getGoodListV3,
  isLogin as isLoginV2,
  getIsLoginV3 as isLoginV3,
  getGoodsDetails as getGoodsDetailsV2,
  apiGet,
  apiPost,
  isLoginWx as isLoginWxV2,
  getIsWxLoginV3 as isLoginWxV3,
  loginWx as loginWxV2,
  loginWxV3,
  getOrderList as getOrderListV2,
  getOrderListV3,
  apiPostV3,
  getOrderDetails as getOrderDetailsV2,
  getCDNGoodsDetails,
} from "jhm_api_ts";
import { Toast } from "vant";

const JhmConfig = require("../../jhm.config.js");

export async function getAreaCache(aid: string): Promise<AreaInfo> {
  if (["v3"].includes(JhmConfig.version)) {
    const result = await getCache(getAreaV3, { aid });
    return result.data;
  } else {
    const result = await getCache(getArea, { id: aid });
    return result.info;
  }
}

export async function getWxConfig(id: "2") {
  let appId = "";
  let jsapiTicket = "";

  if (["v3"].includes(JhmConfig.version)) {
    const result = await getWxConfigV3(id);
    appId = result.data.appid;
    jsapiTicket = result.data.ticket;
  } else {
    const result: any = await getWxConfigV2(id);
    appId = result.info.appId;
    jsapiTicket = result.info.jsapiTicket;
  }

  return {
    appId,
    jsapiTicket,
  };
}

export async function getGoodsList(data: any): Promise<Array<GoodsListItem>> {
  if (["v3"].includes(JhmConfig.version)) {
    const result = await getGoodListV3({
      ...data,
    });

    result.data.forEach((item: any) => {
      try {
        item.h5_extend = JSON.parse(item.h5_extend);
      } catch (e) {
        item.h5_extend = {};
        console.log(item, e);
      }
    });

    return result.data;
  } else {
    const result: any = await getGoodListV2({
      ...data,
    });

    result.info.forEach((item: any) => {
      try {
        item.h5_extend = JSON.parse(item.h5_extend);
      } catch (e) {
        item.h5_extend = {};
        console.log(item, e);
      }
    });

    return result.info;
  }
}

export async function getGoodsDetails(
  gid: string | number
): Promise<GoodsDetails> {
  const { info: result } = await getCDNGoodsDetails(gid);

  const showArr = result.show_mode.split("").reverse();
  // 是否显示门店
  result.is_show_store = showArr[5] == "1";
  // 是否显示流程
  result.is_show_procedure = result.ins_id != "0";
  // 直充详情
  result.charge_type_details =
    (await getRechargesObject(result.charge_type)) || {};
  // 扩展字段初始化
  try {
    if (typeof result.h5_extend === "string") {
      result.h5_extend = JSON.parse(result.h5_extend);
    }
  } catch (e) {
    result.h5_extend = {};
  }
  return result;
}

export async function isLogin(data: any): Promise<LoginedInfo> {
  if (["v3"].includes(JhmConfig.version)) {
    const result = await isLoginV3({
      ...data,
    });

    return {
      u_id: result.data.user_id,
      mobile: result.data.mobile,
    };
  } else {
    const result: any = await isLoginV2({
      ...data,
    });

    return {
      u_id: result.u_id,
      mobile: result.mobile,
    };
  }
}

export async function isLoginWx(data: any): Promise<LoginedWxInfo> {
  if (["v3"].includes(JhmConfig.version)) {
    const { data: result } = await isLoginWxV3({
      ...data,
    });

    return {
      openid: result.openid,
    };
  } else {
    const { data: result } = await isLoginWxV2({
      ...data,
    });

    return {
      openid: result.openid,
    };
  }
}

export async function loginWx(
  pid: string,
  path: string,
  query: any
): Promise<void> {
  if (["v3"].includes(JhmConfig.version)) {
    return new Promise(() => {
      loginWxV3({
        pid,
        backUrl: `${window.location.origin}${window.location.pathname}${window.location.hash}`,
      });
    });
  } else {
    return new Promise(() => {
      loginWxV2(pid, path, query);
    });
  }
}

async function getRechargesObject(charge_type: string): Promise<any> {
  if (Number(charge_type) > 0) {
    const { info }: any = await apiGet(
      "/api/gdekhback/area/get_zhichong_type",
      {
        charge_type,
      }
    );
    return info;
  } else {
    return {};
  }
}

// 新老接口类型不一致 后续避免使用 ===
export async function getOrderList(
  type: "all" | "waitPay" | "more",
  data: any
): Promise<Array<OrderListItem>> {
  if (type === "waitPay") {
    let result = await apiGet("/apiv4/order/payment", data)
      .then((res: any) => {
        return res.data;
      })
      .catch((e) => {
        Toast.fail(e.message || e.info);
        return [];
      });

    result = result.filter(filterSeniority);

    result.map(parseShowMode);

    result.forEach((item: any) => {
      // 是否显示流程
      item.is_show_procedure = item.ins_id != "0";
    });

    return result;
  } else if (type === "all") {
    let result = await apiGet("/apiv4/order/mine", data)
      .then((res: any) => {
        return res.data.list;
      })
      .catch((e) => {
        Toast.fail(e.message || e.info);
        return [];
      });

    result = result.filter(filterSeniority);

    result.map(parseShowMode);

    result.forEach((item: any) => {
      // 是否显示流程
      item.is_show_procedure = item.ins_id != "0";
    });

    return result;
  } else if (type === "more") {
    let result = await apiGet("/apiv4/order/list", data)
      .then((res: any) => {
        return res.data.list;
      })
      .catch((e) => {
        Toast.fail(e.message || e.info);
        return [];
      });

    result = result.filter(filterSeniority);

    result.map(parseShowMode);

    result.forEach((item: any) => {
      // 是否显示流程
      item.is_show_procedure = item.ins_id != "0";
    });

    return result;
  } else {
    return [];
  }

  // 购买权益的商品 支付成功后订单不对客户显示
  function filterSeniority(item: any) {
    return !(
      item.pay_state == 1 &&
      ["1", "2"].includes(item.state) &&
      (item.code_type == "7" || item.notify_type == "14")
    );
  }

  function parseShowMode(item: any) {
    const showArr = item.show_mode.split("").reverse();
    item.is_show_refund = showArr[0] === "1"; // 退款
    item.is_show_code = showArr[1] === "1"; // 券码
    item.is_show_pwd = showArr[2] === "1"; // 密码
    item.is_show_qr_code = showArr[3] === "1"; // 二维码
    item.is_show_href = showArr[4] === "1"; // 链接
    item.is_show_store = showArr[5] === "1"; // 门店
    item.is_show_state_0 = showArr[6] === "1"; // 状态 - 未售出
    item.is_show_state_1 = showArr[7] === "1"; // 状态 - 未使用
    item.is_show_state_2 = showArr[8] === "1"; // 状态 - 已使用
    item.is_show_state_3 = showArr[9] === "1"; // 状态 - 已退款
    item.is_show_state_4 = showArr[10] === "1"; // 状态 - 退款中
    item.is_show_state_5 = showArr[11] === "1"; // 状态 - 已冻结
    item.is_show_consignee = showArr[12] === "1"; // 收件人
    item.is_show_consignee_tel = showArr[13] === "1"; // 收件电话
    item.is_show_consignee_address = showArr[14] === "1"; // 收件地址
    item.is_show_phone = showArr[15] === "1"; // 充值手机号
    item.is_show_oil_card = showArr[16] === "1"; // 充值充值油卡号
    return item;
  }
}

export async function postOrder(data: any): Promise<PostOrderResult> {
  if (["v3"].includes(JhmConfig.version)) {
    return apiPostV3("/apiv3/create/order", data)
      .then((e: any) => {
        return e.data;
      })
      .catch((e) => {
        return Promise.reject({
          status: e.code,
          message: e.message || e.info,
          initData: e,
        } as ErrorInfo);
      });
  } else {
    return await apiPost("/api/gdekhback/phoneext/pro_create_order", data)
      .then((e: any) => {
        return e.info;
      })
      .catch((e) => {
        return Promise.reject({
          status: e.status,
          message: e.info,
          initData: e,
        } as ErrorInfo);
      });
  }
}

export async function cancelOrder(data: any): Promise<any> {
  if (["v3"].includes(JhmConfig.version)) {
    return apiPostV3("/apiv3/cancel-order", data)
      .then((e: any) => {
        return e.data;
      })
      .catch((e) => {
        return Promise.reject({
          status: e.code,
          message: e.message || e.info,
          initData: e,
        } as ErrorInfo);
      });
  } else {
    return await apiPost("/api/gdekhback/phone/order_cancel.html", data)
      .then((e: any) => {
        return e.info;
      })
      .catch((e) => {
        return Promise.reject({
          status: e.status,
          message: e.info,
          initData: e,
        } as ErrorInfo);
      });
  }
}

export async function getOrderDetails(data: any): Promise<any> {
  if (["v3"].includes(JhmConfig.version)) {
    return apiPostV3("/apiv3/order-detail", data)
      .then((e: any) => {
        return e.data;
      })
      .catch((e) => {
        return Promise.reject({
          status: e.code,
          message: e.message || e.info,
          initData: e,
        } as ErrorInfo);
      });
  } else {
    return await getOrderDetailsV2(data)
      .then((e: any) => {
        return e.info;
      })
      .catch((e) => {
        return Promise.reject({
          status: e.status,
          message: e.info,
          initData: e,
        } as ErrorInfo);
      });
  }
}

export async function payOrderICBCWXMini(
  orderInfo: {
    order_id: string;
    pid: string;
    aid: string;
    gid: string;
  },
  backUrl: string
) {
  const ticket = await getTicket();

  const payInfo = await getPayInfo();

  const paramsStr = getParamsStrByPayInfoAndTicket(payInfo, ticket);

  (window as any).wx.miniProgram.navigateTo({
    url: `/pages/pay/pay?${paramsStr}`,
  });

  async function getTicket() {
    const { data }: any = await apiGet("/apiv4/signed/order/icbcWxPay", {
      order_id: orderInfo.order_id,
    }).catch((e) => {
      throw e;
    });
    return data.ticket;
  }

  async function getPayInfo() {
    const { data }: any = await apiGet("/apiv4/signed/order/wechatPay", {
      wx_id: 13,
      pid: orderInfo.pid,
      aid: orderInfo.aid,
      gid: orderInfo.gid,
      order_id: orderInfo.order_id,
    }).catch((e) => {
      throw e;
    });
    return data;
  }

  function getParamsStrByPayInfoAndTicket(payInfo: any, ticket: string) {
    let arr = [];
    arr.push(["timeStamp", payInfo.timeStamp]);
    arr.push(["nonceStr", payInfo.nonceStr]);
    arr.push(["package", payInfo.package]);
    arr.push(["signType", payInfo.signType]);
    arr.push(["paySign", payInfo.paySign]);
    arr.push(["out_trade_no", orderInfo.order_id]);
    arr.push(["ticket", ticket]);
    // 追加时间戳 防止微信缓存
    arr.push([
      "backUrl",
      `${addTimeParams(backUrl)}?order_id=${orderInfo.order_id}`,
    ]);
    arr.push(["mchid", "1494589642"]);
    // 参数转码 拼接
    arr = arr.map((item) => [item[0], encodeURIComponent(item[1])].join("="));

    return arr.join("&");
  }

  function addTimeParams(str: string) {
    const arr = str.split("#");

    if (arr[0].indexOf("?") >= 0) {
      arr[0] = `${arr[0]}&_=${new Date().getTime()}`;
    } else {
      arr[0] = `${arr[0]}?_=${new Date().getTime()}`;
    }
    return arr.join("#");
  }
}
